import React, { useEffect, useState } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { useHistory } from 'react-router-dom';
import banner from "../../images/course-banner.jpg"
import { Markup } from 'interweave';

function CourseData({data}) {
    let navigate = useHistory();
    const [day1,setDay1]=useState();
    const [day2,setDay2]=useState();
    const [day3,setDay3]=useState();
    const [day4,setDay4]=useState();
    const [day5,setDay5]=useState();
    const [day6,setDay6]=useState();
    const [day7,setDay7]=useState();
    const [day8,setDay8]=useState();
    const [day9,setDay9]=useState();
    const [day10,setDay10]=useState();
    const [day11,setDay11]=useState();
    const [day12,setDay12]=useState();
    const [day13,setDay13]=useState();
    const [day14,setDay14]=useState();
    const [day15,setDay15]=useState();
    const [day16,setDay16]=useState();
    const [day17,setDay17]=useState();
    const [day18,setDay18]=useState();
    const [day19,setDay19]=useState();
    const [day20,setDay20]=useState();
    const [day21,setDay21]=useState();
    const [day22,setDay22]=useState();
    const [day23,setDay23]=useState();
    const [day24,setDay24]=useState();
    const [day25,setDay25]=useState();
    const [day26,setDay26]=useState();
    const [day27,setDay27]=useState();
    const [day28,setDay28]=useState();
    const [day29,setDay29]=useState();
    const [day30,setDay30]=useState();
    const [day31,setDay31]=useState();
    const [day32,setDay32]=useState();
    const [day33,setDay33]=useState();
    const [day34,setDay34]=useState();
    const [day35,setDay35]=useState();
    const [day36,setDay36]=useState();
    const [day37,setDay37]=useState();
    // let val=data?.curriculum_data?.find(element => element.data?.start_day===1);
    // setDay(val)
    useEffect(() => {
     setDay1(data?.curriculum_data?.find(element => element.data?.start_day===1))
     setDay2(data?.curriculum_data?.find(element => element.data?.start_day===2))
     setDay3(data?.curriculum_data?.find(element => element.data?.start_day===3))
     setDay4(data?.curriculum_data?.find(element => element.data?.start_day===4))
     setDay5(data?.curriculum_data?.find(element => element.data?.start_day===5))
     setDay6(data?.curriculum_data?.find(element => element.data?.start_day===6))
     setDay7(data?.curriculum_data?.find(element => element.data?.start_day===7))
     setDay8(data?.curriculum_data?.find(element => element.data?.start_day===8))
     setDay9(data?.curriculum_data?.find(element => element.data?.start_day===9))
     setDay10(data?.curriculum_data?.find(element => element.data?.start_day===10))
     setDay11(data?.curriculum_data?.find(element => element.data?.start_day===11))
     setDay12(data?.curriculum_data?.find(element => element.data?.start_day===12))
     setDay13(data?.curriculum_data?.find(element => element.data?.start_day===13))
     setDay14(data?.curriculum_data?.find(element => element.data?.start_day===14))
     setDay15(data?.curriculum_data?.find(element => element.data?.start_day===15))
     setDay16(data?.curriculum_data?.find(element => element.data?.start_day===16))
     setDay17(data?.curriculum_data?.find(element => element.data?.start_day===17))
     setDay18(data?.curriculum_data?.find(element => element.data?.start_day===18))
     setDay19(data?.curriculum_data?.find(element => element.data?.start_day===19))
     setDay20(data?.curriculum_data?.find(element => element.data?.start_day===20))
     setDay21(data?.curriculum_data?.find(element => element.data?.start_day===21))
     setDay22(data?.curriculum_data?.find(element => element.data?.start_day===22))
     setDay23(data?.curriculum_data?.find(element => element.data?.start_day===23))
     setDay24(data?.curriculum_data?.find(element => element.data?.start_day===24))
     setDay25(data?.curriculum_data?.find(element => element.data?.start_day===25))
     setDay26(data?.curriculum_data?.find(element => element.data?.start_day===26))
     setDay27(data?.curriculum_data?.find(element => element.data?.start_day===27))
     setDay28(data?.curriculum_data?.find(element => element.data?.start_day===28))
     setDay29(data?.curriculum_data?.find(element => element.data?.start_day===29))
     setDay30(data?.curriculum_data?.find(element => element.data?.start_day===30))
     setDay31(data?.curriculum_data?.find(element => element.data?.start_day===31))
     setDay32(data?.curriculum_data?.find(element => element.data?.start_day===32))
     setDay33(data?.curriculum_data?.find(element => element.data?.start_day===33))
     setDay34(data?.curriculum_data?.find(element => element.data?.start_day===34))
     setDay35(data?.curriculum_data?.find(element => element.data?.start_day===35))
     setDay36(data?.curriculum_data?.find(element => element.data?.start_day===36))
     setDay37(data?.curriculum_data?.find(element => element.data?.start_day===37))
     
  
    }, [data])
    
  return (
    <>
    <section className="bannercontainer bannerinner">
  {/* <img className="lazy" data-src="images/course-banner.jpg" width="1425" height="623" alt="" /> */}
  <LazyLoadImage
      alt=""
      height={623}
      src={banner} // use normal <img> attributes as props
      width={1425} 
    />
  <div className="bannerinnertext">
    <div className="container">
      <h1><strong>CNC, VMC, HMC MACHINE</strong>MAINTENANCE TRAINING COACH SYLLABUS</h1>
    </div>
  </div>
</section>
<section className="breadcrumbcontainer">
  <div className="container">
    <div className="row">
      <div className="col-12">
        <ol className="breadcrumb">
          <li><a href="/" onClick={(e)=>{e.preventDefault();navigate.push("/")}}>Home</a></li>
          <li className="active">Course</li>                   
        </ol>              
      </div>
    </div>
  </div>
</section>
<section className="dayscontainer">
  <div className="daysinnertp">
    <div className="container">
      <div className="row">
      <div className="col-12">
          {/* <h1 className="mtitel" style={{fontSize:"40px",textAlign:"center"}}>THEORY</h1> */}
        </div>
            <div className="tpheading">
              <h3><span>{`Day ${day1?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
              day1?.curriculum_data?.map((item,idx)=>{
                return <>
                {idx===0?<div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4">
          <div className="courseul day1">
            <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
            {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
            {item?.chapter_sub_heading&& <Markup style={{lineHeight: "30px"}} content={item?.chapter_sub_heading} />
            // <p>{item?.chapter_sub_heading}jhvjfg</p>
            }
            {/* <p>What is a CNC machine?</p> */}
            {JSON.parse(item?.curriculum_list).length>0&&
                <ul>
                    {JSON.parse(item?.curriculum_list).map(item=>{
                        return <li>{item}</li>
                    })}
                </ul>}
                {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
          </div>
        </div>:<div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
          <div className={item?.curriculum_chapter=="1.2"?"courseul ul50":"courseul"}>
          <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
          {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
          {JSON.parse(item?.curriculum_list).length>0&&
                <ul>
                    {JSON.parse(item?.curriculum_list).map(item=>{
                        return <li>{item}</li>
                    })}
                </ul>}
                {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
          </div>
        </div>}
                </>
              })
            }
      </div>
    </div>
  </div>
  <div className="daysinnerbt">
    <div className="container">
      <div className="row">
      
             <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
            <div className="tpheading">
            <h3><span>{`Day ${day2?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
              day2?.curriculum_data?.map((item,idx)=>{
                return <div className="courseul ul50">
          <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
          {item?.chapter_heading&&<Markup  content={item?.chapter_heading} />}
          {JSON.parse(item?.curriculum_list).length>0&&
                <ul>
                    {JSON.parse(item?.curriculum_list).map(item=>{
                        return <li>{item}</li>
                    })}
                </ul>}
                {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
          </div>
             
              })
            }
            </div>
        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
            <div className="tpheading">
              <h3><span>{`Day ${day3?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
              day3?.curriculum_data?.map((item,idx)=>{
                return <div className="courseul ul30">
          <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
          {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
          {JSON.parse(item?.curriculum_list).length>0&&
                <ul>
                    {JSON.parse(item?.curriculum_list).map(item=>{
                        return <li>{item}</li>
                    })}
                </ul>}
                {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
          </div>
             
              })
            }
        </div>
      </div>
    </div>
  </div>
</section>

<section className="dayscontainer">
  <div className="container">
    <div className="row">
      <div className="col-12">
        <div className="tpheading">
          <h3><span>{`Day ${day4?.data?.start_day}`}</span><span></span></h3>
        </div>
      </div>
      {
        day4?.curriculum_data?.map((item,idx)=>{
         return <>
         { idx===0?
          <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
          <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
          {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
          {JSON.parse(item?.curriculum_list).length>0&&
                <ul>
                    {JSON.parse(item?.curriculum_list).map(item=>{
                        return <li>{item}</li>
                    })}
                </ul>}
                {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
          </div>
        </div>: <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 mb-4">
        <div className="courseul ul30">
        <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
          {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
          {JSON.parse(item?.curriculum_list).length>0&&
                <ul>
                    {JSON.parse(item?.curriculum_list).map(item=>{
                        return <li>{item}</li>
                    })}
                </ul>}
                {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
        </div>
      </div>}
         </>
        })
      }
      
     
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
        <div className="courseul ul50">
          <div className="tpheading">
            <h3><span>{`Day ${day5?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day5?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day6?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day6?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4">
        <div className="courseul ul20">
          <div className="tpheading">
            <h3><span>{`Day ${day7?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day7?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
    </div>
  </div>
</section>

<section className="dayscontainer">
  <div className="daysinnertp">
    <div className="container">
      <div className="row">
        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day8?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day8?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day9?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day9?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day10?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day10?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="daysinnerbt">
    <div className="container">
      <div className="row">
        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day11?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day11?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day12?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day12?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day13?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day13?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<Markup style={{lineHeight: "30px"}} content={`<h4>${item?.chapter_heading}</h4>`} />
        //  <h4>{item?.chapter_heading}</h4>
         }
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="dayscontainer">
  <div className="container">
    <div className="row">
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day14?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day14?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day15?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day15?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day16?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day16?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day17?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day17?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day18?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day18?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
    </div>
  </div>
</section>

<section className="dayscontainer">
  <div className="daysinnertp">
    <div className="container">
      <div className="row">
        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day19?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day19?.curriculum_data?.map((item,idx)=>{
         return<>
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day20?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day20?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="daysinnerbt">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h1 className="mtitel" style={{fontSize:"40px"}}>PRACTICAL</h1>
        </div>
        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day21?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day21?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day22?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day22?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day23?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day23?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day24?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day24?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
        <div className="col-12">
          <hr/>
        </div>
        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day25?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day25?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day26?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day26?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day27?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day27?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
          <div className="courseul">
            <div className="tpheading">
              <h3><span>{`Day ${day28?.data?.start_day}`}</span><span></span></h3>
            </div>
            {
        day28?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="dayscontainer">
  <div className="container">
    <div className="row">
      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day29?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day29?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day30?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day30?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day31?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day31?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li>{item}</li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day32?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day32?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-12">
        <hr/>
      </div>
      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day33?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day33?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day34?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day34?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day35?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day35?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-4">
        <div className="courseul">
          <div className="tpheading">
            <h3><span>{`Day ${day36?.data?.start_day}`}</span><span></span></h3>
          </div>
          {
        day36?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4">
        <div className="courseul ul30">
          <div className="tpheading">
            <h3><span>{`Day ${day37?.data?.start_day} to  ${day37?.data?.end_day}`}</span><span></span></h3>
          </div>
          {
        day37?.curriculum_data?.map((item,idx)=>{
         return<>
         
         <div className="dpoint"><span>{item?.curriculum_chapter}</span><span></span></div>
         {item?.chapter_heading&&<h4>{item?.chapter_heading}</h4>}
         {JSON.parse(item?.curriculum_list).length>0&&
               <ul>
                   {JSON.parse(item?.curriculum_list).map(item=>{
                       return <li><Markup  content={item} /></li>
                   })}
               </ul>}
               {item?.add_etc==="yes"?<div className="typeany"><span>ETC</span></div>:null}
         </>})}
        </div>
      </div>
    </div>
  </div>
</section>
{/* <section className="dayscontainer">

{
    data&&data.curriculum_data.map((item,idx)=>{
       return <div className="daysinnertp">
        <div className="container">
          <div className="row">
                <div className="tpheading">
                  <h3><span>{`Day ${item.data.start_day}`}</span><span></span></h3>
                </div>
                {item.curriculum_data.map(item=>{
                  return  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4">
              <div className="courseul">
           
                <div className="dpoint"><span>{item.curriculum_chapter}</span><span></span></div>
                <h4>{item.chapter_heading}</h4>
                {item.chapter_sub_heading&&<p>{item.chapter_sub_heading}</p>}
               
                {JSON.parse(item.curriculum_list).length>0&&
                
                <ul>
                    {JSON.parse(item.curriculum_list).map(item=>{
                        return <li>{item}</li>
                    })}
                </ul>}
                {item.add_etc==="yes"==="yes"?<div className="typeany"><span>ETC</span></div>:null}
              </div>
            </div>
})}
          </div>
        </div>
      </div>
    })
}
</section> */}
    </>
  )
}

export default CourseData